var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"newsfeeds",attrs:{"id":"newsfeed-items-grid"}},[_c('timeline-review',{attrs:{"signedIn":_vm.signedIn}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }